import { warningTriangle } from '@/assets/icons/lib';
import { cn } from '@/functions/cn';

const PageError = ({
  className,
  text = '정보를 불러오는 중 오류가 발생했습니다',
  subText = '잠시 후 다시 확인해주세요.',
}: {
  className?: string;
  text?: string;
  subText?: string;
}) => {
  return (
    <div className={cn('_flex-center text-center flex-col h-full', className)}>
      <img
        src={warningTriangle}
        className="w-[50px] h-[50px] mb-16 text-red-500"
      />
      <div className="text-paragraph-m-medium text-b-gray-800 mb-4">{text}</div>
      <div className="text-paragraph-s-regular text-b-gray-500">{subText}</div>
    </div>
  );
};

export default PageError;
